export type InventoryStatus =
  | 'IN STOCK'
  | 'LOW STOCK'
  | 'OUT OF STOCK'
  | 'UNAVAILABLE';

export function deriveInventoryStatus(
  stock: number,
  isAvailable: boolean,
  lowStockThreshold = 5
): InventoryStatus {
  if (!isAvailable) return 'UNAVAILABLE';
  if (stock <= 0) return 'OUT OF STOCK';
  if (stock <= lowStockThreshold) return 'LOW STOCK';
  return 'IN STOCK';
}

export function inventoryStatusTone(status: InventoryStatus): string {
  switch (status) {
    case 'IN STOCK':
      return 'badge-success bg-emerald-500/10 text-emerald-600 border-emerald-500/20';
    case 'LOW STOCK':
      return 'badge-warning bg-amber-500/10 text-amber-600 border-amber-500/20';
    case 'OUT OF STOCK':
      return 'badge-error bg-rose-500/10 text-rose-600 border-rose-500/20';
    default:
      return 'badge-ghost bg-base-200 text-base-content/60 border-base-300';
  }
}
